import React from "react";
import { WidgetWrapper } from "./WidgetWrapper";
import { REPORT_TYPES, VERTICALS } from "../../constants/app-constant";
import {
  sovRankingFilter,
  sovTrendFilter,
} from "../NewsAndAnalysis/Analysis/AnalysisGroup/filter-constant";
import { useSelector } from "react-redux";

export const WidgetList = ({
  filteredWidgets,
  user_id,
  history,
  selectedDashboard,
  showTodaysFeedWidget,
  handleTodayFeedWidgeStatus,
  fetchWidgets,
  setWidgetCreationStatus,
  setFilteredWidgets,
  widgets,
  setWidgets,
  enableDownloadFn,
  setGraphRefList,
}) => {
  const selectedClient =
    useSelector(
      (state) => state.clientReducer && state.clientReducer.selectedClient
    ) || {};

  return filteredWidgets.map((widget) => {
    if (!widget) return;
    console.log("line no 32 ",selectedClient)
    //need to add condition of widget type and tv access
    if ((widget.type == VERTICALS.V_PRINT && selectedClient.is_print_access == "0") || (widget.type == VERTICALS.V_ONLINE && selectedClient.is_online_access == "0")) return;
    let filterOption = [];
    if (
      [
        REPORT_TYPES.SOVNOARanking,
        REPORT_TYPES.SOVCCMRanking,
        REPORT_TYPES.SOVMAVRanking,
      ].indexOf(widget.report_type) >= 0
    ) {
      filterOption = sovRankingFilter;
    }
    if (
      [
        REPORT_TYPES.SOV_NOA_TREND,
        REPORT_TYPES.SOV_CCM_TREND,
        REPORT_TYPES.SOV_MAV_TREND,
      ].indexOf(widget.report_type) >= 0
    ) {
      filterOption = sovTrendFilter;
    }

    return (
      <WidgetWrapper
        user_id={user_id}
        widget={widget}
        history={history}
        selectedDashboard={selectedDashboard}
        showTodaysFeedWidget={showTodaysFeedWidget}
        handleTodayFeedWidgeStatus={handleTodayFeedWidgeStatus}
        fetchWidgets={fetchWidgets}
        setWidgetCreationStatus={setWidgetCreationStatus}
        setFilteredWidgets={setFilteredWidgets}
        filteredWidgets={filteredWidgets}
        widgets={widgets}
        setWidgets={setWidgets}
        enableDownloadFn={enableDownloadFn}
        setGraphRefList={setGraphRefList}
        filterOption={filterOption}
      ></WidgetWrapper>
    );
  });
};
